<ng-container [formGroup]="form">
  <mat-form-field appearance="outline" subscriptSizing="dynamic">
    @if (label()) {
      <mat-label>{{ label() }}</mat-label>
    }
    <input
      matInput
      formControlName="date"
      [matDatepicker]="picker"
      readonly
      (focus)="picker.open()"
      (click)="picker.open()"
      (blur)="onBlur()"
      autocomplete="off" />
    <mat-datepicker-toggle matPrefix [for]="picker" />
    <mat-datepicker #picker startView="year" />
    <mat-hint>DD MMMM</mat-hint>
    @if (InputValidation.checkInputErrors(date)) {
      <qaroni-input-error-messages matError [fc]="date" />
    }
  </mat-form-field>
</ng-container>
